import React from "react";
import { Spinner } from "react-bootstrap";

interface LoadingSpinnerProps {
    message: string
}

export const LoadingSpinnerSmall = ({ message }: LoadingSpinnerProps) => {
    return (
        <div className="align-items-center" style={{fontSize: "12px"}}>
            <span>
                <Spinner animation="border" variant="secondary" />
            </span> {message}
        </div>
    );
}

